"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileDevice = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const isMobileDevice = () => {
    var _a;
    const uiParser = new ua_parser_js_1.UAParser();
    return ((_a = (uiParser.getDevice().type === ua_parser_js_1.UAParser.DEVICE.MOBILE || uiParser.getDevice().type === ua_parser_js_1.UAParser.DEVICE.TABLET)) !== null && _a !== void 0 ? _a : false);
};
exports.isMobileDevice = isMobileDevice;
